export function sortLavoratori(lavoratori)  {
    return lavoratori.sort((a, b) => {
        if (a.cognome === b.cognome) {
            return a.nome.localeCompare(b.nome);
        }
        return a.cognome.localeCompare(b.cognome);
    });
};